import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';
import StripeGateway from './stripeGateway';
import PaypalGateway from './paypalGateway';
import PaymentwallGateway from './paymentwallGateway';
import CoingateGateway from './coingateGateway';
import ApplePayGateway from './applePayGateway';
import GpayGateway from './gpayGateway';
import GatePayGateway from "./gatePayGateway";
import store from '../../store/index';

let state = store.state.cartState ? store.state.cartState : {};

const gatewayList = {
  stripe: StripeGateway,
  paypal: PaypalGateway,
  paymentwall: PaymentwallGateway,
  coingate: CoingateGateway,
  applepay: ApplePayGateway,
  gpay: GpayGateway,
  gatepay: GatePayGateway,
};

export default class PaymentProcessor {
  constructor(gatewayName) {
    this.gatewayName = gatewayName;
  }

  async process() {
    let gatewayInstance = {};

    if (gatewayList[this.gatewayName]) {
      gatewayInstance = new gatewayList[this.gatewayName]();
    } else {
      gatewayInstance = new PaymentGatewayProcessor();
    }

    return gatewayInstance.processCheckout();
  }
}
